import { useQuery } from "@tanstack/react-query";
import {
  CompanyAssignmentConfigDto,
  GetCompanyAssignmentConfigDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_QUESTIONS_ASSIGNMENT } from "../domain";

import { questionsAssignmentApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_GET_COMPANIES_ASSIGNMENT_CONFIG =
  "GET_COMPANIES_ASSIGNMENT_CONFIG";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const getCompaniesAssignmentConfig = async (
  dto: GetCompanyAssignmentConfigDto,
): Promise<CompanyAssignmentConfigDto[]> => {
  const response =
    await questionsAssignmentApi.assignmentsConfigControllerGetCompaniesAssignmentConfig(
      dto,
    );

  return response.data;
};

export const useGetCompaniesAssignmentConfig = (
  user: UserProfileDto | null,
  dto: GetCompanyAssignmentConfigDto,
  enable: boolean = true,
): {
  companiesAssignmentConfig?: CompanyAssignmentConfigDto[];
  companiesAssignmentConfigEnabled: boolean;
  isPendingGetCompaniesAssignmentConfig: boolean;
  isLoadingGetCompaniesAssignmentConfig: boolean;
  isSuccessGetCompaniesAssignmentConfig: boolean;
  isFetchingGetCompaniesAssignmentConfig: boolean;
} => {
  const enabled = enable && roleGuard(user, allowedRoles);
  const { isPending, data, isLoading, isSuccess, isFetching } = useQuery({
    queryKey: [
      DOMAIN_QUESTIONS_ASSIGNMENT,
      ACTION_GET_COMPANIES_ASSIGNMENT_CONFIG,
      dto,
    ],
    queryFn: () => getCompaniesAssignmentConfig(dto),
    enabled,
    staleTime: 0,
  });

  return {
    companiesAssignmentConfig: data,
    companiesAssignmentConfigEnabled: enabled,
    isPendingGetCompaniesAssignmentConfig: isPending,
    isLoadingGetCompaniesAssignmentConfig: isLoading,
    isSuccessGetCompaniesAssignmentConfig: isSuccess,
    isFetchingGetCompaniesAssignmentConfig: isFetching,
  };
};
